<template>
  <div class="checkout-timer" :class="state_class">{{ display }}</div>
</template>

<script>
import { timer_display } from "@liveflight/utilities";

export default {
  name: "checkout-timer",
  props: {
    start: {
      type: Number,
      default: 0,
    },
    amount: {
      type: Number,
      default: 120,
    },
  },
  data() {
    return {
      now: Date.now(),
      tick_handle: null,
    };
  },
  mounted() {
    if (!this.start) return;
    this.tick_handle = setInterval(() => {
      this.now = Date.now();
      if (this.is_expired) {
        this.$emit("expired");
        this.clear_ticker();
      }
    }, 250);
  },
  beforeDestroy() {
    this.clear_ticker();
  },
  computed: {
    duration_ms() {
      return this.amount * 1000;
    },
    remaining_ms() {
      if (!this.start) {
        return 0;
      }
      const elapsed = this.now - this.start;
      return this.duration_ms - elapsed;
    },
    is_expired() {
      return this.start > 0 && this.remaining_ms <= 0;
    },
    is_warning() {
      return !this.is_expired && this.remaining_ms <= 120 * 1000;
    },
    state_class() {
      if (this.is_expired) return "checkout-timer--expired";
      if (this.is_warning) return "checkout-timer--warning";
      return "";
    },
    display() {
      if (!this.start) return "--:--";
      if (this.is_expired) return "La proposta è scaduta";
      return `La proposta scade tra ${timer_display(this.remaining_ms)}`;
    },
  },
  methods: {
    clear_ticker() {
      if (this.tick_handle) {
        clearInterval(this.tick_handle);
        this.tick_handle = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.checkout-timer {
  font-family: $font-family-monospace;
  font-size: $font-size-lg;
  color: $gray-600;
  margin-bottom: 0.5rem;
  font-weight: $vb-font-weight-semibold;

  &--warning,
  &--expired {
    color: $danger;
  }
}
</style>
